export default __webpack_public_path__ + "static/media/FoodBGPattern.96fb1a6d.png";